import { ref } from 'vue';

const licenseAlertVisible = ref(false);

const displayLicenseAlert = (): void => {
	licenseAlertVisible.value = true;
};

const hideLicenseAlert = (): void => {
	licenseAlertVisible.value = false;
};

export {
	licenseAlertVisible,
	displayLicenseAlert,
	hideLicenseAlert,
};
